module.exports = __webpack_public_path__ + "img/137.2426f8df.jpg";